var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStrongInfo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 15,
  height: 15,
  x: 2,
  y: 2,
  fill: "#fff",
  rx: 7.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10 0c5.52 0 10 4.48 10 10s-4.48 10-10 10S0 15.52 0 10 4.48 0 10 0m0 16c.733 0 1.333-.6 1.333-1.333 0-.734-.6-1.334-1.333-1.334s-1.333.6-1.333 1.334C8.667 15.4 9.267 16 10 16M8.473 5.66l.447 5.347a1.082 1.082 0 0 0 2.16 0l.447-5.347a1.534 1.534 0 1 0-3.06-.127c0 .04 0 .087.006.127"
})));
export default SvgStrongInfo;